module.exports = {

    login: function (url, identity, credential) {
        return $.ajax({
            type: "post",
            url: url,
            dataType: "json",
            data: {
                "email": identity,
                "password": credential
            }
        });
    },

    resendValidationEmail: function(url, email) {
        
        $.ajax({
            type: "post",
            dataType: "html",
            data: {
                "referrerUrl": "",
                "password": "",
                "email": email,
                "resendValidation": "Resend Account Validation"
            },
            url: url,
            success: function() {

            },
            error: function() {

            }
        });
    },

    resetPassword: function(url, email) {
        $.ajax({
            type: "post",
            dataType: "html",
            data: {
                "referrerUrl": "",
                "password": "abc123",
                "email": email,
                "forgottenPassword": "Reset Password"
            },
            url: url,
            success: function() {

            },
            error: function() {
                
            }
        });
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/Managers/MHL.js
 **/